import axios from 'axios'
import qs from 'qs'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
var basePath = 'http://www.beiyv.com';

axios.defaults.timeout = 8000;

axios.interceptors.request.use(config => {
	const method = config.method.toLowerCase()
	// post/put/patch 统一序列化
	if (['post', 'put', 'patch'].includes(method) && config.data) {
		config.data = qs.stringify(config.data)
	}
	return config
}, error => {
	console.error('请求参数错误：', error)
	return Promise.reject(error)
})

axios.interceptors.response.use(res => {
	//console.log(res);
	return res.data // 直接剥离一层，页面少写一层 .data
}, error => {
	console.error('接口请求出错：', error)
	return Promise.reject(error)
})
// 公共处理返回数据
function handleResponse(res) {
	//console.log(res)
	// 登录失效统一处理
	return res
}
export function post(url, params) {
	return axios.post(basePath + url, params).then(handleResponse)
}

export function get(url, params) {
	return axios.get(basePath + url, {
		params
	}).then(handleResponse)
}


export default {
	setCookie(key, value, day) {
		const maxAge = day * 24 * 60 * 60;
		document.cookie = `${key}=${encodeURIComponent(value)}; max‑age=${maxAge}; path=/; SameSite=Lax`;
	},
	/* setCookie(cname, cvalue, expires) {
		document.cookie = cname + "=" + cvalue + "; " + expires;
	}, */
	getCookie(name) {
		var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg)) {
			return arr[2];
		} else {
			return '';
		}
	},
	delCookie(name) {
		const exp = new Date();
		exp.setTime(exp.getTime() - 1);
		// 直接赋值空值+过期，无需getCookie
		document.cookie = `${name}=;expires=${exp.toGMTString()};path=/`;
	},
	isWeiXin() {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	},

	/**
	 * 获取列表
	 */
	getList(params) {
		return post('/iapi/getList.php', params)
	},
	
	/**
	 * 获取列表
	 */
	getListBypid(params) {
		return post('/iapi/getListBypid.php', params)
	},
	
	/**
	 * 获取详情
	 */
	getItem(params) {
		return post('/iapi/getItem.php', params)
	},
	
	
	/**
	 * 保存数据
	 */
	saveInfo(params) {
		return post('/iapi/saveInfo.php', params)
	},
	
	/**
	 * 注册
	 */
	register(params) {
		return post('/iapi/register.php', params)
	},
	
	/**
	 * 登录
	 */
	login(params) {
		return post('/iapi/login.php', params)
	},
	
	/**
	 * 登录
	 */
	search(params) {
		return post('/iapi/search.php', params)
	},
	
	/**
	 * 获取会员信息
	 */
	getMemberInfo(params) {
		return post('/iapi/getMemberInfo.php', params)
	},
	
	/**
	 * 保存会员信息
	 */
	setUserInfo(params) {
		return post('/iapi/setUserInfo.php', params)
	},
	
	/**
	 * 获取所有栏目
	 */
	getCategoryList(params) {
		return post('/iapi/getCategoryList.php', params)
	},
	
	/**
	 * 获取用户提示词列表
	 */
	getListByUser(params) {
		return post('/iapi/getListByUser.php', params)
	},
	
	/**
	 * 获取用户提示词列表
	 */
	getListByAll(params) {
		return post('/iapi/getListByAll.php', params)
	},
	
	/**
	 * 审核通过
	 */
	setAudit(params) {
		return post('/iapi/setAudit.php', params)
	},
	
	/**
	 * 提交建议或意见
	 */
	saveSuggest(params) {
		return post('/iapi/saveSuggest.php', params)
	},
	
	/**
	 * 获取栏目下文章数量
	 */
	getNumberBycat(params) {
		return post('/iapi/getNumberBycat.php', params)
	},
	
	/**
	 * 修改密码
	 */
	setUserPassword(params) {
		return post('/iapi/setUserPassword.php', params)
	},
	
	/**
	 * 获取用户列表
	 */
	getUserList(params) {
		return post('/iapi/getUserList.php', params)
	},
	
	/**
	 * 修改提示词
	 */
	setWordInfo(params) {
		return post('/iapi/setWordInfo.php', params)
	},
	
	/**
	 * 设置会员等级
	 */
	setUserLv(params) {
		return post('/iapi/setUserLv.php', params)
	},
}



// WEBPACK FOOTER //
// ./src/api/api.js